import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import Header from "../Component/Header";
import Contents from "../Component/Contents";
import Buttons from "../Component/Buttons";
import Cont from "../Component/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import * as actions from "../Actions";
import TargetPic from "../Img/Target.png";

class Target extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="fadeIn">
        <Cont className="container">
          <Header
            title={TargetPic}
            desc="누구에게 쓰는 글인가요?"
            stage="1"
          ></Header>
          <Contents
            stage="target"
            placeholder="타겟은 구체적일수록 좋아요!"
          ></Contents>
          <Buttons
            array={[
              [<FontAwesomeIcon icon={faTimes} />, "/", this.props.clear],
              [<FontAwesomeIcon icon={faArrowRight} />, "/opinion"]
            ]}
          ></Buttons>
        </Cont>
        {/* <Footer stage="1"></Footer> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    text: state.Reducer.text
  };
};

const mapDispatchToProps = dispatch => {
  return {
    upload: (title, content) => {
      dispatch(actions.write(title, content));
    },
    clear: () => {
      dispatch(actions.clear());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Target);
